const API_URL = process.env.VUE_APP_API_URL;

async function getRoom(roomId, token) {
  const options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  const response = await fetch(`${API_URL}/api/buttons/${roomId}`, options);

  if (response.status === 403) {
    throw new Error("forbidden");
  } else if (response.status === 404) {
    throw new Error("not-found");
  } else if (response.status === 500) {
    throw new Error("UNKNOWN");
  }

  const json = await response.json();
  return json.result;
}

async function createCall(roomId, isTechnician, token) {
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      id: roomId,
      data: isTechnician ? "0201" : "0200",
    }),
  };

  const response = await fetch(`${API_URL}/callPowerAutomate`, options);
  return response.json();
}
async function createCallWithInformations(
  roomId,
  isTechnician,
  userInformation
) {
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer`,
    },
    body: JSON.stringify({
      id: roomId,
      data: isTechnician ? "0201" : "0200",
      user: userInformation,
    }),
  };
  const response = await fetch(`${API_URL}/callPowerAutomate`, options);
  return response.json();
}

export { getRoom, createCall, createCallWithInformations };
